import { AISchemaType } from "components/server-types";

export const assessmentSchema: AISchemaType = {
  $schema: "https://json-schema.org/draft/2020-12/schema",
  type: "object",
  title: "AssessmentSchema",
  description:
    "AssessmentSchema provides a schema for LLM output to be coerced into a structured outcome assessment.",
  additionalProperties: false,
  properties: {
    outcomes: {
      type: "object",
      description:
        "A mapping of outcome titles to scores, where the title is e.g. `#some-title` (without backticks) and the score " +
        "is a number from 0 to 4 corresponding to the rubric index (if it exists). Empty if the response is refused, " +
        "otherwise every outcome must have a score.",
      patternProperties: {
        "^#.*$": {
          type: "integer",
          minimum: 0,
          maximum: 4,
        },
      },
      additionalProperties: false,
    },
    feedback: {
      type: "string",
      description:
        "A comment directed at the student, explaining the reasoning and giving feedback. Focused on giving formative " +
        "feedback for how the student could specifically improve. Empty string if the response is refused.",
    },
    refused: {
      type: ["string", "null"],
      description:
        "If assessment was refused, this is the objective reason, without using 'I' or personal perspective. Empty if " +
        "the response is not refused.",
    },
  },
  required: ["outcomes", "feedback"],
};
